import { useState } from 'react';
import { useMessageHandler } from '~/Features/Messaging/useMessageHandler';
import type { ScrollLockState } from '~/Utils/ScrollLock/ScrollLockUpdated';
import { ScrollLockUpdated } from '~/Utils/ScrollLock/ScrollLockUpdated';

export function useScrollLockNotifier() {
    const [scrollLockState, setScrollLockState] = useState<ScrollLockState>({
        isLocked: false,
    });

    useMessageHandler(ScrollLockUpdated.id, (event: ScrollLockUpdated) => {
        setScrollLockState(event.state);
    });

    return scrollLockState;
}
